var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailActionUnread(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.89,5.83a.18.18,0,0,0-.2,0l-9.75,9.75a2.72,2.72,0,0,1-1.94.8,2.79,2.79,0,0,1-1.95-.8L.31,5.87a.18.18,0,0,0-.2,0A.18.18,0,0,0,0,6V18a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6A.18.18,0,0,0,23.89,5.83Z",
    fill: "currentColor",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.11,14.56a1.27,1.27,0,0,0,1.77,0l9.69-9.69a.5.5,0,0,0,.12-.51C22.58,4,22.27,4,22,4H2c-.28,0-.58,0-.69.36a.5.5,0,0,0,.12.51Z",
    fill: "currentColor",
    strokeWidth: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailActionUnread);
export default __webpack_public_path__ + "static/media/email-action-unread.927adab2.svg";
export { ForwardRef as ReactComponent };